// extracted by mini-css-extract-plugin
export default {"icon__container":"icon__container_IKmxf_xP","icon__bg--circle":"icon__bg--circle_Iaox3Arz"};